import { Action } from '@ngrx/store';
import { Deal, DealVersion } from '../../types/deal.types';
import { ColumnSortModel } from '../../grid/types/sorting.types';
import { ManagerGridColumnName } from '../../grid/types/column.types';
import { Order } from '../../types/order.types';
import { ManagerFiltersActionUnion } from '../manager-filters/actions';
import { ManagerSelectionActionUnion } from './selection/actions';

export enum ManagerActionTypes {
  LoadManager = '[Manager] Load',
  LoadManagerSuccess = '[Manager] Load Success',
  LoadManagerFail = '[Manager] Load Fail',
  RemoveManagerDeals = '[Manager] Remove Manager Deals',
  TaintManager = '[Manager] Taint',
  ManagerIsActive = '[Manager] Is Active',
  ManagerSetSortModel = '[Manager] Set Sort Model',
  ManagerViewTypeChanged = '[Manager] View Type Changed',
  ManagerLoadDealDetails = '[Manager] Manager Load Deal Details',
  ManagerLoadDealDetailsSuccess = '[Manager] Manager Load Deal Orders Success',
  ManagerLoadDealDetailsFailed = '[Manager] Manager Load Deal Orders Failed'
}

export class LoadManager implements Action {
  public readonly type = ManagerActionTypes.LoadManager;

  constructor(public showLoading: boolean = true) {}
}

export class LoadManagerSuccess implements Action {
  public readonly type = ManagerActionTypes.LoadManagerSuccess;

  constructor(public payload: { data: DealVersion[] }) {}
}

export class LoadManagerFail implements Action {
  public readonly type = ManagerActionTypes.LoadManagerFail;

  constructor(public error: string) {}
}

export class RemoveManagerDeals implements Action {
  public readonly type = ManagerActionTypes.RemoveManagerDeals;

  constructor(public dealIds: string[]) {}
}

export class TaintManager implements Action {
  public readonly type = ManagerActionTypes.TaintManager;
}

export class ManagerIsActive implements Action {
  public readonly type = ManagerActionTypes.ManagerIsActive;

  constructor(public isActive: boolean) {}
}

export class ManagerSetSortModel implements Action {
  public readonly type = ManagerActionTypes.ManagerSetSortModel;

  constructor(public sortModel: ColumnSortModel<ManagerGridColumnName>[]) {}
}

export class ManagerViewTypeChanged implements Action {
  public readonly type = ManagerActionTypes.ManagerViewTypeChanged;

  constructor(public viewType: string) {}
}

export class ManagerLoadDealDetailsSuccess implements Action {
  public readonly type = ManagerActionTypes.ManagerLoadDealDetailsSuccess;

  constructor(
    public payload: { dealId: string; orders: Order[]; dealDetails: Deal }
  ) {}
}

export class ManagerLoadDealDetailsFailed implements Action {
  public readonly type = ManagerActionTypes.ManagerLoadDealDetailsFailed;

  constructor(public payload: { dealId: string; error: string }) {}
}

export type ManagerActionUnion =
  | LoadManager
  | LoadManagerSuccess
  | LoadManagerFail
  | RemoveManagerDeals
  | TaintManager
  | ManagerIsActive
  | ManagerSetSortModel
  | ManagerViewTypeChanged
  | ManagerLoadDealDetailsSuccess
  | ManagerLoadDealDetailsFailed
  | ManagerFiltersActionUnion
  | ManagerSelectionActionUnion;
